export const white = {
  white1: "#FFF",
  white2: "#F1F9F2",
  white3: "#F5F5F5",
  white4: "#FCF8EE",
  white5: "#F0F5FA",
};
